import {Mapper} from '@s-ui/domain'

const DEFAULT_PAGE = 1
const DEFAULT_SIZE = 30

export class FromSearchRequestVOToSubscriptionSearchRequestVOMapper extends Mapper {
  constructor({config, subscriptionSearchRequestValueObjectFactory}) {
    super()
    this._config = config
    this._subscriptionSearchRequestValueObjectFactory = subscriptionSearchRequestValueObjectFactory
    this._sortFields = this._config.get('SORT_FIELDS')
    this._sortQueryParams = this._config.get('SORT_QUERY_PARAM')
    this._adsListSize = this._config.get('search').ADS_LIST_SIZE
  }

  _getSortTerm = ({sortBy}) => {
    // dealing with monthly subscription fee sorting field on subscription means using price on request
    if (sortBy === this._sortFields.MONTHLY_SUBSCRIPTION_FEE) return this._sortFields.PRICE.toLowerCase()

    return sortBy?.toLowerCase() || null
  }

  map = searchRequestValueObject => {
    const {
      bodyTypeIds,
      commitmentMonths,
      fuelTypeIds,
      makeId,
      monthlySubscriptionFee: {from: priceFrom, to: priceTo} = {},
      page,
      sortBy,
      sortOrder,
      subscriptionVehicleState,
      transmissionTypeId
    } = searchRequestValueObject.toJSON()

    const filters = {
      bodyTypeIds,
      commitmentMonths,
      fuelTypeIds,
      price: {
        from: priceFrom || null,
        to: priceTo || null
      },
      subscriptionVehicleState,
      transmissionTypeId: transmissionTypeId || null,
      vehicles: [{makeId}]
    }

    const pagination = {
      page: Number(page) || DEFAULT_PAGE,
      size: this._adsListSize || DEFAULT_SIZE
    }

    return this._subscriptionSearchRequestValueObjectFactory({
      filters,
      pagination,
      sort: {
        order: sortOrder?.toLowerCase() || null,
        term: this._getSortTerm({sortBy})
      }
    })
  }
}
